import { createRoute } from "@routes/utils";

import { settingsRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = "all";

const settingsRouteMetadata: IRouteMetadataObj<typeof settingsRoutesObj> = {
  home: {
    title: "settings.title",
    description: "empty",
    lazy: () => import("@pages/settings/page"),
    mode: "index",
    type: "inner",
    icon: "Settings2Line",
    breadcrumbs: [],
    permission,
  },
};

export const settingsRoutes = createRoute<typeof settingsRoutesObj>(
  settingsRoutesObj,
  settingsRouteMetadata,
);
